import React, { useContext } from 'react';
import { makeStyles, Box } from '@material-ui/core';
import clsx from 'clsx';
import { AddCircle, RemoveCircle } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { MatrixDispatchContext } from '../CreateEditMatrixProvider';

const useStyles = makeStyles(theme => ({
  boxIcons: {
    display: 'flex',
    padding: '5.6px 0px',
    marginLeft: '6.6px',
    flexDirection: 'column',
    height: '40px',
    justifyContent: 'space-between',
  },
  icon: {
    padding: 0,
    color: theme.palette.neutrals[4],
    width: '10.8px',
    height: '10.8px',
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.neutrals[6],
    },
  },
  disabled: {
    pointerEvents: 'none',
  },
}));

const BoxIcons = ({ idx, inputRef, type, chooseOnly }) => {
  const classes = useStyles();
  const dispatch = useContext(MatrixDispatchContext);

  return (
    <Box className={clsx(classes.boxIcons, { [classes.disabled]: chooseOnly })}>
      <AddCircle
        className={classes.icon}
        onClick={() => {
          inputRef.current.stepUp();
          dispatch({
            type: type === 'individual' ? 'UPDATE_INDIVIDUAL_TIME' : 'UPDATE_GROUP_TIME',
            payload: {
              idx,
              value: inputRef.current.value,
            },
          });
        }}
      />
      <RemoveCircle
        className={classes.icon}
        onClick={() => {
          inputRef.current.stepDown();
          dispatch({
            type: type === 'individual' ? 'UPDATE_INDIVIDUAL_TIME' : 'UPDATE_GROUP_TIME',
            payload: {
              idx,
              value: inputRef.current.value,
            },
          });
        }}
      />
    </Box>
  );
};

BoxIcons.defaultProps = {
  type: null,
  inputRef: null,
  chooseOnly: false,
};

BoxIcons.propTypes = {
  idx: PropTypes.number.isRequired,
  type: PropTypes.string,
  inputRef: PropTypes.object,
  chooseOnly: PropTypes.bool,
};

export default React.memo(BoxIcons);
